import { inject, Injectable } from '@angular/core';

import { BaseResponseDto, DeleteMissionRequest, GetMissionFilter, Mission } from '@aoe/client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import { SessionStorageService } from '../session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class MissionsService extends ApiService {

  private readonly sessionService = inject(SessionStorageService);


  getMissions(filters: GetMissionFilter): Observable<BaseResponseDto<Mission.MissionListDto>> {
    return this.http.get<BaseResponseDto<Mission.MissionListDto>>(`${environment.apiVolunteers}/mission`, { headers: { 'Authorization': `Bearer ${this.sessionService.token}` }, params: { ...filters } });
  }

  deleteMission(req: DeleteMissionRequest) {
    return this.http.delete<BaseResponseDto<Mission.MissionListDto>>(`${environment.apiVolunteers}/mission/${req.id}`);
  }

}
